import JSRSA from 'jsrsasign'

// 模数
const modulus = '00819e01b823e6bf5d6aa33972642274c429d045f6e65af6d77eb84f1814a3810c96316c8a5f4072597c5948d4aa205c'
  + 'f798f34b1e5640e73aa193184001a670fbd5afc5fd47228c597ceebb5e64ccf9cfab0ff27b330bb6f95ea8eea7bc71331cd7e52d7c88a355c0e'
  + 'f17ce125e7307631200c17a0a00312d6918678482fb6b9f'

const encrypt = (str: string) => {
  const key = JSRSA.KEYUTIL.getKey({
    n: modulus,
    e: '010001'
  }) as JSRSA.RSAKey
  return JSRSA.KJUR.crypto.Cipher.encrypt(str, key, 'RSAOAEP256')
}

export default encrypt
